type RuntimeEnvironment = {
  NODE_ENV?: string;
  REACT_APP_E2E_AUTH?: string;
  REACT_APP_E2E_REGION?: string;
};

export const E2E_AUTH_TOKEN = "playwright-e2e";

/**
 * Browser authentication bypass for the local Playwright harness.
 *
 * CRA replaces NODE_ENV at build time, so the production build can never turn
 * this on even if REACT_APP_E2E_AUTH is accidentally present in its environment.
 */
export const isE2EAuthEnabled = (
  environment: RuntimeEnvironment = process.env
): boolean => {
  const runtime = environment.NODE_ENV;
  return (
    (runtime === "development" || runtime === "test") &&
    environment.REACT_APP_E2E_AUTH === "true"
  );
};

export const getE2ERegion = (
  environment: RuntimeEnvironment = process.env
): string | null => {
  if (!isE2EAuthEnabled(environment)) return null;
  return environment.REACT_APP_E2E_REGION?.trim().toLowerCase() || "dev";
};
